import { Button } from "@client/components/ui";
import { useT } from "@client/i18n";

export function ShowInModelButton({
  preset,
  label,
  onShow,
}: {
  preset: string | undefined;
  label?: string;
  onShow(presetId: string): void;
}) {
  const t = useT();
  if (!preset) return null;
  return (
    <Button size="sm" variant="secondary" onClick={() => onShow(preset)}>
      {label ?? t("teacher.prep.showInModel")}
    </Button>
  );
}
